.spectrum--darkest .spectrum-Button.focus-ring {
    box-shadow: 0 0 0 1px rgb(20, 115, 230);
  }
.spectrum--darkest .spectrum-Button:active {
    box-shadow: none;
  }
.spectrum--darkest .spectrum-ClearButton {
  background-color: transparent;

  color: rgb(162, 162, 162);
}
.spectrum--darkest .spectrum-ClearButton:hover {
    background-color: transparent;

    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ClearButton:active {
    background-color: transparent;

    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ClearButton.focus-ring {
    background-color: transparent;

    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ClearButton:disabled,
.spectrum--darkest .spectrum-ClearButton.is-disabled {
    background-color: transparent;

    color: rgb(73, 73, 73);
  }
.spectrum--darkest .spectrum-Button--cta {
  background-color: rgb(20, 115, 230);
  border-color: rgb(20, 115, 230);
  color: rgb(255, 255, 255);
}
.spectrum--darkest .spectrum-Button--cta:hover {
    background-color: rgb(13, 102, 208);
    border-color: rgb(13, 102, 208);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--cta.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--cta:active {
    background-color: rgb(13, 102, 208);
    border-color: rgb(13, 102, 208);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--cta:disabled,
.spectrum--darkest .spectrum-Button--cta.is-disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-Button--primary {
  background-color: transparent;
  border-color: rgb(200, 200, 200);
  color: rgb(200, 200, 200);
}
.spectrum--darkest .spectrum-Button--primary:hover {
    background-color: rgb(200, 200, 200);
    border-color: rgb(200, 200, 200);
    color: rgb(8, 8, 8);
  }
.spectrum--darkest .spectrum-Button--primary.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--primary:active {
    background-color: rgb(239, 239, 239);
    border-color: rgb(239, 239, 239);
    color: rgb(8, 8, 8);
  }
.spectrum--darkest .spectrum-Button--primary:disabled,
.spectrum--darkest .spectrum-Button--primary.is-disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-Button--secondary {
  background-color: transparent;
  border-color: rgb(162, 162, 162);
  color: rgb(162, 162, 162);
}
.spectrum--darkest .spectrum-Button--secondary:hover {
    background-color: rgb(162, 162, 162);
    border-color: rgb(162, 162, 162);
    color: rgb(8, 8, 8);
  }
.spectrum--darkest .spectrum-Button--secondary.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--secondary:active {
    background-color: rgb(200, 200, 200);
    border-color: rgb(200, 200, 200);
    color: rgb(8, 8, 8);
  }
.spectrum--darkest .spectrum-Button--secondary:disabled,
.spectrum--darkest .spectrum-Button--secondary.is-disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-Button--warning {
  background-color: transparent;
  border-color: rgb(236, 91, 98);
  color: rgb(236, 91, 98);
}
.spectrum--darkest .spectrum-Button--warning:hover {
    background-color: rgb(236, 91, 98);
    border-color: rgb(236, 91, 98);
    color: rgb(8, 8, 8);
  }
.spectrum--darkest .spectrum-Button--warning.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--warning:active {
    background-color: rgb(247, 109, 116);
    border-color: rgb(247, 109, 116);
    color: rgb(8, 8, 8);
  }
.spectrum--darkest .spectrum-Button--warning:disabled,
.spectrum--darkest .spectrum-Button--warning.is-disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-Button--overBackground {
  background-color: transparent;
  border-color: rgb(255, 255, 255);
  color: rgb(255, 255, 255);
}
.spectrum--darkest .spectrum-Button--overBackground:hover {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
  }
.spectrum--darkest .spectrum-Button--overBackground.focus-ring {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
    box-shadow: 0 0 0 1px rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--overBackground:active {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
    box-shadow: none;
  }
.spectrum--darkest .spectrum-Button--overBackground:disabled,
.spectrum--darkest .spectrum-Button--overBackground.is-disabled {
    background-color: rgba(255,255,255,0.1);
    border-color: transparent;
    color: rgba(255,255,255,0.35);
  }
.spectrum--darkest .spectrum-Button--overBackground.spectrum-Button--quiet,
.spectrum--darkest .spectrum-ClearButton--overBackground {
  background-color: transparent;
  border-color: transparent;
  color: rgb(255, 255, 255);
}
.spectrum--darkest .spectrum-Button--overBackground.spectrum-Button--quiet:hover,
.spectrum--darkest .spectrum-ClearButton--overBackground:hover {
    background-color: rgba(255,255,255,0.1);
    border-color: transparent;
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--overBackground.spectrum-Button--quiet.focus-ring,
.spectrum--darkest .spectrum-ClearButton--overBackground.focus-ring {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
    box-shadow: 0 0 0 1px rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--overBackground.spectrum-Button--quiet:active,
.spectrum--darkest .spectrum-ClearButton--overBackground:active {
    background-color: rgba(255,255,255,0.15);
    border-color: transparent;
    color: rgb(255, 255, 255);
    box-shadow: none;
  }
.spectrum--darkest .spectrum-Button--overBackground.spectrum-Button--quiet:disabled,
.spectrum--darkest .spectrum-Button--overBackground.spectrum-Button--quiet.is-disabled,
.spectrum--darkest .spectrum-ClearButton--overBackground:disabled,
.spectrum--darkest .spectrum-ClearButton--overBackground.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgba(255,255,255,0.15);
  }
.spectrum--darkest .spectrum-Button--primary.spectrum-Button--quiet {
  background-color: transparent;
  border-color: transparent;
  color: rgb(200, 200, 200);
}
.spectrum--darkest .spectrum-Button--primary.spectrum-Button--quiet:hover {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-Button--primary.spectrum-Button--quiet.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--primary.spectrum-Button--quiet:active {
    background-color: rgb(57, 57, 57);
    border-color: rgb(57, 57, 57);
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-Button--primary.spectrum-Button--quiet:disabled,
.spectrum--darkest .spectrum-Button--primary.spectrum-Button--quiet.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-Button--secondary.spectrum-Button--quiet {
  background-color: transparent;
  border-color: transparent;
  color: rgb(162, 162, 162);
}
.spectrum--darkest .spectrum-Button--secondary.spectrum-Button--quiet:hover {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(200, 200, 200);
  }
.spectrum--darkest .spectrum-Button--secondary.spectrum-Button--quiet.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--secondary.spectrum-Button--quiet:active {
    background-color: rgb(57, 57, 57);
    border-color: rgb(57, 57, 57);
    color: rgb(200, 200, 200);
  }
.spectrum--darkest .spectrum-Button--secondary.spectrum-Button--quiet:disabled,
.spectrum--darkest .spectrum-Button--secondary.spectrum-Button--quiet.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-ActionButton,
.spectrum--darkest .spectrum-Tool {
  background-color: rgb(26, 26, 26);
  border-color: rgb(57, 57, 57);
  color: rgb(200, 200, 200);
}
.spectrum--darkest .spectrum-ActionButton .spectrum-Icon,
.spectrum--darkest .spectrum-Tool .spectrum-Icon {
    color: rgb(162, 162, 162);
  }
.spectrum--darkest .spectrum-ActionButton .spectrum-ActionButton-hold,
.spectrum--darkest .spectrum-Tool .spectrum-ActionButton-hold {
    color: rgb(162, 162, 162);
  }
.spectrum--darkest .spectrum-ActionButton:hover,
.spectrum--darkest .spectrum-Tool:hover {
    background-color: rgb(8, 8, 8);
    border-color: rgb(73, 73, 73);
    box-shadow: none;
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ActionButton:hover .spectrum-Icon,
.spectrum--darkest .spectrum-Tool:hover .spectrum-Icon {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton:hover .spectrum-ActionButton-hold,
.spectrum--darkest .spectrum-Tool:hover .spectrum-ActionButton-hold {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton.focus-ring,
.spectrum--darkest .spectrum-Tool.focus-ring {
    background-color: rgb(8, 8, 8);
    border-color: rgb(20, 115, 230);
    box-shadow: 0 0 0 1px rgb(20, 115, 230);
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ActionButton.focus-ring .spectrum-Icon,
.spectrum--darkest .spectrum-Tool.focus-ring .spectrum-Icon {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton.focus-ring .spectrum-ActionButton-hold,
.spectrum--darkest .spectrum-Tool.focus-ring .spectrum-ActionButton-hold {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton:active,
.spectrum--darkest .spectrum-Tool:active {
    background-color: rgb(44, 44, 44);
    border-color: rgb(73, 73, 73);
    box-shadow: none;
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ActionButton:active .spectrum-ActionButton-hold,
.spectrum--darkest .spectrum-Tool:active .spectrum-ActionButton-hold {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton:disabled,
.spectrum--darkest .spectrum-ActionButton.is-disabled,
.spectrum--darkest .spectrum-Tool:disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-ActionButton:disabled .spectrum-Icon,
.spectrum--darkest .spectrum-ActionButton.is-disabled .spectrum-Icon,
.spectrum--darkest .spectrum-Tool:disabled .spectrum-Icon {
      color: rgb(73, 73, 73);
    }
.spectrum--darkest .spectrum-ActionButton:disabled .spectrum-ActionButton-hold,
.spectrum--darkest .spectrum-ActionButton.is-disabled .spectrum-ActionButton-hold,
.spectrum--darkest .spectrum-Tool:disabled .spectrum-ActionButton-hold {
      color: rgb(73, 73, 73);
    }
.spectrum--darkest .spectrum-ActionButton.is-selected {
    background-color: rgb(44, 44, 44);
    border-color: rgb(57, 57, 57);
    color: rgb(200, 200, 200);
  }
.spectrum--darkest .spectrum-ActionButton.is-selected .spectrum-Icon {
      color: rgb(162, 162, 162);
    }
.spectrum--darkest .spectrum-ActionButton.is-selected.focus-ring {
      background-color: rgb(44, 44, 44);
      border-color: rgb(20, 115, 230);
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton.is-selected.focus-ring .spectrum-Icon {
        color: rgb(239, 239, 239);
      }
.spectrum--darkest .spectrum-ActionButton.is-selected:hover {
      background-color: rgb(44, 44, 44);
      border-color: rgb(73, 73, 73);
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton.is-selected:hover .spectrum-Icon {
        color: rgb(239, 239, 239);
      }
.spectrum--darkest .spectrum-ActionButton.is-selected:active {
      background-color: rgb(44, 44, 44);
      border-color: rgb(73, 73, 73);
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton.is-selected:active .spectrum-Icon {
        color: rgb(239, 239, 239);
      }
.spectrum--darkest .spectrum-ActionButton.is-selected:disabled,
.spectrum--darkest .spectrum-ActionButton.is-selected.is-disabled {
      background-color: rgb(44, 44, 44);
      border-color: rgb(44, 44, 44);
      color: rgb(92, 92, 92);
    }
.spectrum--darkest .spectrum-ActionButton.is-selected:disabled .spectrum-Icon,
.spectrum--darkest .spectrum-ActionButton.is-selected.is-disabled .spectrum-Icon {
        color: rgb(73, 73, 73);
      }
.spectrum--darkest .spectrum-ActionButton--quiet,
.spectrum--darkest .spectrum-Tool {
  background-color: transparent;
  border-color: transparent;
  color: rgb(200, 200, 200);
}
.spectrum--darkest .spectrum-ActionButton--quiet:hover,
.spectrum--darkest .spectrum-Tool:hover {
    background-color: transparent;
    border-color: transparent;
    color: rgb(239, 239, 239);
    box-shadow: none;
  }
.spectrum--darkest .spectrum-ActionButton--quiet.focus-ring,
.spectrum--darkest .spectrum-Tool.focus-ring {
    background-color: transparent;
    box-shadow: 0 0 0 1px rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-ActionButton--quiet:active,
.spectrum--darkest .spectrum-Tool:active {
    background-color: rgb(57, 57, 57);
    border-color: rgb(57, 57, 57);
    color: rgb(239, 239, 239);
    box-shadow: none;
  }
.spectrum--darkest .spectrum-ActionButton--quiet:disabled,
.spectrum--darkest .spectrum-ActionButton--quiet.is-disabled,
.spectrum--darkest .spectrum-Tool:disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-ActionButton--quiet.is-selected {
    background-color: rgb(57, 57, 57);
    border-color: rgb(57, 57, 57);
    color: rgb(200, 200, 200);
  }
.spectrum--darkest .spectrum-ActionButton--quiet.is-selected.focus-ring {
      background-color: rgb(57, 57, 57);
      border-color: rgb(20, 115, 230);
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton--quiet.is-selected:hover {
      background-color: rgb(57, 57, 57);
      border-color: rgb(57, 57, 57);
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton--quiet.is-selected:active {
      background-color: rgb(57, 57, 57);
      border-color: rgb(57, 57, 57);
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-ActionButton--quiet.is-selected:disabled,
.spectrum--darkest .spectrum-ActionButton--quiet.is-selected.is-disabled {
      background-color: rgb(44, 44, 44);
      border-color: rgb(44, 44, 44);
      color: rgb(92, 92, 92);
    }
.spectrum--darkest .spectrum-Button--warning.spectrum-Button--quiet {
  background-color: transparent;
  border-color: transparent;
  color: rgb(236, 91, 98);
}
.spectrum--darkest .spectrum-Button--warning.spectrum-Button--quiet:hover {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(247, 109, 116);
  }
.spectrum--darkest .spectrum-Button--warning.spectrum-Button--quiet.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-Button--warning.spectrum-Button--quiet:active {
    background-color: rgb(57, 57, 57);
    border-color: rgb(57, 57, 57);
    color: rgb(247, 109, 116);
  }
.spectrum--darkest .spectrum-Button--warning.spectrum-Button--quiet:disabled,
.spectrum--darkest .spectrum-Button--warning.spectrum-Button--quiet.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-LogicButton--and {
  background-color: rgb(38, 128, 235);
  border-color: rgb(38, 128, 235);
  color: rgb(255, 255, 255);
}
.spectrum--darkest .spectrum-LogicButton--and:hover {
    background-color: rgb(75, 156, 245);
    border-color: rgb(75, 156, 245);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-LogicButton--and.focus-ring {
    background-color: rgb(75, 156, 245);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-LogicButton--and:disabled,
.spectrum--darkest .spectrum-LogicButton--and.is-disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-LogicButton--or {
  background-color: rgb(216, 55, 144);
  border-color: rgb(216, 55, 144);
  color: rgb(255, 255, 255);
}
.spectrum--darkest .spectrum-LogicButton--or:hover {
    background-color: rgb(236, 90, 170);
    border-color: rgb(236, 90, 170);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-LogicButton--or.focus-ring {
    background-color: rgb(236, 90, 170);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--darkest .spectrum-LogicButton--or:disabled,
.spectrum--darkest .spectrum-LogicButton--or.is-disabled {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-FieldButton {
  color: rgb(200, 200, 200);
  background-color: rgb(26, 26, 26);
  border-color: rgb(57, 57, 57);
}
.spectrum--darkest .spectrum-FieldButton:hover {
    color: rgb(239, 239, 239);
    background-color: rgb(8, 8, 8);
    border-color: rgb(73, 73, 73);
  }
.spectrum--darkest .spectrum-FieldButton.focus-ring,
.spectrum--darkest .spectrum-FieldButton.is-focused {
    background-color: rgb(8, 8, 8);
    border-color: rgb(20, 115, 230);
    box-shadow: 0 0 0 1px rgb(20, 115, 230);
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-FieldButton.focus-ring.is-placeholder,
.spectrum--darkest .spectrum-FieldButton.is-focused.is-placeholder {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-FieldButton:active,
.spectrum--darkest .spectrum-FieldButton.is-selected {
    background-color: rgb(44, 44, 44);
    border-color: rgb(73, 73, 73);
  }
.spectrum--darkest .spectrum-FieldButton:active.focus-ring,
.spectrum--darkest .spectrum-FieldButton:active.is-focused,
.spectrum--darkest .spectrum-FieldButton.is-selected.focus-ring,
.spectrum--darkest .spectrum-FieldButton.is-selected.is-focused {
      box-shadow: none;
    }
.spectrum--darkest .spectrum-FieldButton.is-invalid {
    border-color: rgb(227, 72, 80);
  }
.spectrum--darkest .spectrum-FieldButton.is-invalid:hover {
      border-color: rgb(236, 91, 98);
    }
.spectrum--darkest .spectrum-FieldButton.is-invalid:active,
.spectrum--darkest .spectrum-FieldButton.is-invalid.is-selected {
      border-color: rgb(236, 91, 98);
    }
.spectrum--darkest .spectrum-FieldButton.is-invalid.focus-ring,
.spectrum--darkest .spectrum-FieldButton.is-invalid.is-focused {
      border-color: rgb(20, 115, 230);
      box-shadow: 0 0 0 1px rgb(20, 115, 230);
    }
.spectrum--darkest .spectrum-FieldButton:disabled,
.spectrum--darkest .spectrum-FieldButton.is-disabled {
    background-color: rgb(44, 44, 44);
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-FieldButton:disabled.focus-ring,
.spectrum--darkest .spectrum-FieldButton.is-disabled.focus-ring {
      box-shadow: none;
    }
.spectrum--darkest .spectrum-FieldButton:disabled .spectrum-Icon,
.spectrum--darkest .spectrum-FieldButton.is-disabled .spectrum-Icon {
      color: rgb(73, 73, 73);
    }
.spectrum--darkest .spectrum-FieldButton--quiet {
  color: rgb(200, 200, 200);
  border-color: transparent;
  background-color: transparent;
}
.spectrum--darkest .spectrum-FieldButton--quiet:hover {
    background-color: transparent;
    color: rgb(239, 239, 239);
  }
.spectrum--darkest .spectrum-FieldButton--quiet.focus-ring,
.spectrum--darkest .spectrum-FieldButton--quiet.is-focused {
    background-color: transparent;
    box-shadow: 0 2px 0 0 rgb(20, 115, 230);
  }
.spectrum--darkest .spectrum-FieldButton--quiet.focus-ring.is-placeholder,
.spectrum--darkest .spectrum-FieldButton--quiet.is-focused.is-placeholder {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-FieldButton--quiet:active,
.spectrum--darkest .spectrum-FieldButton--quiet.is-selected {
    background-color: transparent;
    border-color: transparent;
  }
.spectrum--darkest .spectrum-FieldButton--quiet:active.focus-ring,
.spectrum--darkest .spectrum-FieldButton--quiet:active.is-focused,
.spectrum--darkest .spectrum-FieldButton--quiet.is-selected.focus-ring,
.spectrum--darkest .spectrum-FieldButton--quiet.is-selected.is-focused {
      background-color: transparent;
      box-shadow: 0 2px 0 0 rgb(20, 115, 230);
    }
.spectrum--darkest .spectrum-FieldButton--quiet.is-invalid.focus-ring,
.spectrum--darkest .spectrum-FieldButton--quiet.is-invalid.is-focused {
      box-shadow: 0 2px 0 0 rgb(20, 115, 230);
    }
.spectrum--darkest .spectrum-FieldButton--quiet:disabled,
.spectrum--darkest .spectrum-FieldButton--quiet.is-disabled {
    background-color: transparent;
    color: rgb(92, 92, 92);
  }
.spectrum--darkest .spectrum-FieldButton--quiet:disabled.focus-ring,
.spectrum--darkest .spectrum-FieldButton--quiet.is-disabled.focus-ring {
      box-shadow: none;
    }
.spectrum--darkest .spectrum-Tool.is-selected .spectrum-Icon {
      color: rgb(38, 128, 235);
    }
.spectrum--darkest .spectrum-Tool.is-selected .spectrum-Tool-hold {
      color: rgb(38, 128, 235);
    }
.spectrum--darkest .spectrum-Tool.is-selected:hover .spectrum-Icon {
        color: rgb(55, 142, 240);
      }
.spectrum--darkest .spectrum-Tool.is-selected:hover .spectrum-Tool-hold {
        color: rgb(55, 142, 240);
      }
.spectrum--darkest .spectrum-Tool.is-selected:active .spectrum-Icon {
        color: rgb(75, 156, 245);
      }
.spectrum--darkest .spectrum-Tool.is-selected:active .spectrum-Tool-hold {
        color: rgb(75, 156, 245);
      }
.spectrum--darkest .spectrum-Tool.is-selected.focus-ring .spectrum-Icon {
        color: rgb(55, 142, 240);
      }
.spectrum--darkest .spectrum-Tool.is-selected.focus-ring .spectrum-Tool-hold {
        color: rgb(55, 142, 240);
      }
.spectrum--darkest .spectrum-Tool.is-selected:disabled,
.spectrum--darkest .spectrum-Tool.is-selected.is-disabled {
      background-color: transparent;
      border-color: transparent;
    }
.spectrum--darkest .spectrum-Tool.is-selected:disabled .spectrum-Icon,
.spectrum--darkest .spectrum-Tool.is-selected.is-disabled .spectrum-Icon {
        color: rgb(73, 73, 73);
      }
.spectrum--darkest .spectrum-Tool.is-selected:disabled .spectrum-Tool-hold,
.spectrum--darkest .spectrum-Tool.is-selected.is-disabled .spectrum-Tool-hold {
        color: rgb(73, 73, 73);
      }
.spectrum--darkest .spectrum-Tool .spectrum-Tool-hold {
    color: rgb(162, 162, 162);
  }
.spectrum--darkest .spectrum-Tool:hover .spectrum-Tool-hold {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-Tool:active {
    background-color: transparent;
    border-color: transparent;
  }
.spectrum--darkest .spectrum-Tool:active .spectrum-Tool-hold {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-Tool.focus-ring .spectrum-Tool-hold {
      color: rgb(239, 239, 239);
    }
.spectrum--darkest .spectrum-Tool.is-disabled .spectrum-Tool-hold,
.spectrum--darkest .spectrum-Tool:disabled .spectrum-Tool-hold {
      color: rgb(73, 73, 73);
    }
